import { combineReducers } from "redux";
import { createMerchantReducer } from "./reducers/createMerchantReducer";
import { editMerchantReducer } from "./reducers/editMerchantReducer";
import { getMerchantsReducer } from "./reducers/getMerchantsReducer";
import { payoutAuthReducer } from "./reducers/payoutAuthReducer";
import { authReducer } from "./reducers/authReducer";

import { otpReducer } from "./reducers/otpReducer";
import { resendOtpReducer } from "./reducers/resendOtpReducer";
import { createUserReducer } from "./reducers/createUserReducer";
import { merchantReducer } from "./reducers/merchantReducer";
import { outLetsByMerchantReducer } from "./reducers/outLetsByMerchantReducer";
import { outletDetailsReducer } from "./reducers/outletDetailsReducer";
import { getUsersReducer } from "./reducers/getUsersReducer";
import { getTerminalsReducer } from "./reducers/getTerminalsReducer";
import { merchantSummaryReducer } from "./reducers/merchantSummaryReducer";
import { userSummaryReducer } from "./reducers/userSummaryReducer";
import { getOutletsTerminalsReducer } from "./reducers/getOutletsTerminalsReducer";
import { getUsersByOutletId } from "./reducers/getUsersByOutlet";
import { getUsersTerminalsReducer } from "./reducers/getUsersTerminalsReducer";
import { getUsersTransactionsReducer } from "./reducers/getUsersTransactionsReducer";
import { getTsnTransactionsReducer } from "./reducers/getTsnTransactionsReducer";
import { getTerminalSummaryReducer } from "./reducers/getTerminalSummaryReducer";
import { getOutletSummaryReducer } from "./reducers/getOutletSummaryReducer";
import { editUserReducer } from "./reducers/editUserReducer";
import { editOutletReducer } from "./reducers/editOutletReducer";
import { addOutletReducer } from "./reducers/addOutletReducer";
import { getListOfCurrency } from "./reducers/getListOfCurrency";
import { addCurrencyReducer } from "./reducers/addCurrencyReducer";
import { addNewTransferChargeReducer } from "./reducers/addNewTransferChargeReducer";

import { getListOfBusinessCategory } from "./reducers/gitListOfBusinessCategory";
import { getListOfFilterSearchReducer } from "./reducers/getListOfFilterSearchReducer";
import { getCountriesCitiesReducer } from "./reducers/getCountriesCities";
import { ResetPasswordFirstLoginReducer } from "./reducers/resetPasswordAfterFirstLog";
import { AddTerminalReducer } from "./reducers/addTerminalReducer";
import { getMerchntTransactionsReducer } from "./reducers/getMerchantTransactionReducer";
import { DeleteTerminalReducer } from "./reducers/deleteTerminalReducer";
import { getMerchantTodayBalanceReducer } from "./reducers/getMerchantTodayBalanceReducer";
import { getTopUsedTerminalReducer } from "./reducers/getTopusedTerminalReducer";
import { getlast7DaysTransactionCountReducer } from "./reducers/getMerchantTransactionCountReducer";
import { getMerchantCurrentPreviousReducer } from "./reducers/getCurrenetPreviousMonthReducer";
import { getMerchantUsedSchemeReducer } from "./reducers/getTranactionUsedSchemeReducer";
import { getTerminalsTransactionChartReducer } from "./reducers/getTerminalsTransactionChartReducer";
import { getOutletsTransactionChartReducer } from "./reducers/getOutletsTransactionChartReducer";
import { getMerchantAvailableTerminalReducer } from "./reducers/getMerchantAvailableTerminalReducer";
import { AddTerminalTmsCardReducer } from "./reducers/AddTerminalCardSchemeReducer";
import { AddTerminalRetailerReducer } from "./reducers/AddTerminalRetailerDataReducer";
import { editTerminalReducer } from "./reducers/editTerminalReducer";

import { getReconcilationHistoryReducer } from "./reducers/getReconcilationHistoryReducer";
import { createInvoiceReducer } from "./reducers/CreateInvoiceReducer";
import { merchantInvoicesReducer } from "./reducers/getInvoicesList";
import { getPaymentConfigReducer } from "./reducers/getPaymentConfigReducer";
import { addMerchantPaymentConfigurationReducer } from "./reducers/addMerchantPaymentConfig";
import { merchantInvoiceReducer } from "./reducers/getMerchantInvoiceReducer";
import { getInvoicePaymentUrlReducer } from "./reducers/getPaymentUrlReducer";
import { EditInvoiceStatusReducer } from "./reducers/editInvoiceStatusReducer";
import { transactionsFilterReducer } from "./reducers/getFilterTransactionReducer";
import { SendInvoiceNotificationReducer } from "./reducers/sendInvoiceNotificationReducer";
import { invoicesFilterReducer } from "./reducers/getFilterInvoicesReducer";
import { getReconciliationFilterReducer } from "./reducers/getFilterReconciliationReducer";
import paymentGatewayTransactionReducer from "./reducers/getPaymentGatewayTransReducer";
import dashboardDataReducer from "./reducers/paymentDashboard";
import { fetchDashboardData } from "./actions/paymentDashboard";
import paymentGatewayHighlightsReducer from "./reducers/paymentGatewayHighlightsReducer";
import payementMethodsReducer from "./reducers/getPaymentMethodReducer";
import geopayementReducer from "./reducers/getGeoPaymentReducer";
import paymentChartReducer from "./reducers/getPaymentChartReducer";
import { addApplePayConfigReducer } from "./reducers/addApplePayConfig";
import { updateCardConfigReducer } from "./reducers/updateCardConfigRed";
import { getMerchantPaymentConfigReducer } from "./reducers/getMerchantPaymentConfigReducer";
import { addUrpayConfigReducer } from "./reducers/addUrpayConfigReducer";
import { addCardConfigReducer } from "./reducers/addCardConfigReducer";
import { geturpayConfigReducer } from "./reducers/geturpayConfigReducer";
import { updateurpayConfigReducer } from "./reducers/updateUrpayConfigReducer";
import { forgotPwReducer } from "./reducers/forgotPwReducer";
import { findAppleConfigReducer } from "./reducers/findAppleConfigReducer";
import { updateAppleConfigReducer } from "./reducers/updateAppleConfigReducer";
import { addNewMerchantReducer } from "./reducers/addNewMerchantReducer";
import { manafithReducer } from "./reducers/addmanafithConfigurationReducer";
import { addNewCustomerReducer } from "./reducers/addNewCustomerReducer";
import { getCustomerListReducer } from "./reducers/getCustomerListReducer";
import { addNewProductReducer } from "./reducers/addNewProductReducer";
import { getProductListReducer } from "./reducers/getProductListReducer";
import { DeleteProductReducer } from "./reducers/deleteProductReducer";
import { DeleteCustomerReducer } from "./reducers/deleteCustomerReducer";
import { editCustomerReducer } from "./reducers/editCustomersReducer";
import { editProductReducer } from "./reducers/editProductsReducer";
import { sadadConfigReducer } from "./reducers/sadadPaymentConfig";
import { getTerminalsListReducer } from "./reducers/getTerminalsListReducer";
import { TamaraReducer } from "./reducers/addtamarhreducer";
import { getAllCountryReducer } from "./reducers/getAllCountryReducer";
import { getAllCurrencyReducer } from "./reducers/getAllCurrencyReducer";

import { getAllTransferChargeReducer } from "./reducers/getAllTransferChargeReducer";

import { addNewCountryReducer } from "./reducers/addNewCountryReducer";
import { editCountryReducer } from "./reducers/editCountryReducer";
import { getAllCityReducer } from "./reducers/getAllCityReducer";
import { addNewCityReducer } from "./reducers/addNewCityReducer";
import { addNewCurrencyReducer } from "./reducers/addNewCurrencyReducer";
import { getAllTmsReducer } from "./reducers/getAllTmsReducer";
import { getAllBusinessCategoryReducer } from "./reducers/getAllBusinessCategory";
import { updateBusCatReducer } from "./reducers/updateBusinessCatReducer";
import { getAllRetailerReducer } from "./reducers/getAllRetailerReducer";
import { editRetailerReducer } from "./reducers/editRetailerReducer";
import { addRetailerReducer } from "./reducers/addRetailerReducer";
import { editCurrencyReducer } from "./reducers/editNewCurrencyReducer";
import { editTransferChargeReducer } from "./reducers/editTransferChargeReducer";

import { deleteTransferChargeReducer } from "./reducers/deleteTransferChargeReducer";

import { deleteCurrencyReducer } from "./reducers/deleteCurrencyReducer";
import { addBusinessCategoryReducer } from "./reducers/addBsCategoryReducer";
import { activateBusinessCategoryReducer } from "./reducers/activateBusCatReducer";
import { deactivateBusinessCategoryReducer } from "./reducers/deactivateBusCatReducer";
import { editCityReducer } from "./reducers/editCityReducer";
import { addTmsReducer } from "./reducers/addTmsReducer";
import { activateTMSReducer } from "./reducers/activateTmsReducer";
import { deactivateTmsReducer } from "./reducers/deactivateTmsReducer";
import { paymentGatewayTrxReducer } from "./reducers/PaymentGatewayTrxReducer";
import { partnerCrudReducer } from "./reducers/PartnerCrudReducer";
import { merchantOnlineRegisterReducer } from "./reducers/merchantOnlineRegisterReducer";
import { deleteMerchantReducer } from "./reducers/deleteMerchantReducer";
import { partnerReducer } from "./reducers/partnerReducer";
import { getAuditReducer } from "./reducers/getAuditLogReducer";
import { getAllPaymentGyListReducer } from "./reducers/getPaymentGyReducer";
import { getApplePayTrxReducer } from "./reducers/getApplePayTransactions";
import { getOnBoardingFilesReducer } from "./reducers/getOnboardingFilesReducer";
import { versionsCrudOperationsReducer } from "./reducers/addVersionReducer";
import { partnerThemeCrudOperationsReducer } from "./reducers/getPartnerThemeReducer";

import { getAllFeeProfileReducer } from "./reducers/getAllFeeProfileReducer";
import { getAssociatedBanksReducer } from "./reducers/getAssociatedBanksReducer";

import { addFeeProfileReducer } from "./reducers/addFeeProfileReducer";
import { editFeeProfileReducer } from "./reducers/editFeeProfileReducer";
import { ChangeFeeProfileStatusReducer } from "./reducers/changeFeeProfileStatus";
import { DeleteFeeProfileReducer } from "./reducers/deleteFeeProfileReducer";
import { feePlanReducer } from "./reducers/feePlanReducer";

import { getPayoutTransactionsReportsReducer } from "./reducers/getPayoutTransactionsReportsReducer";
import { getPOSTransactionsReportsReducer } from "./reducers/getPOSTransactionsReportsReducer";

import { payoutMerchantCrudReducer } from "./reducers/payoutMerchantCrudReducer";
import { resendFailedVirtualAccountsReducer } from "./reducers/resendFailedVirtualAccountsReducer";

import { getMerchantPosTransctionsReducer } from "./reducers/getMerchantPosTransctionsReducer";
import { paymentScheduleCrudReducer } from "./reducers/paymentScheduleCrudReducer";
import { singlePayoutTransactionReducer } from "./reducers/singlePayoutTransactionReducer";

import { payoutTransactionsReducer } from "./reducers/payoutTransactionsReducer";
import { payoutMerchantsReducer } from "./reducers/payoutMerchantsReducer";
import { getVirtualAccountsReducer } from "./reducers/getVirtualAccountsReducer";
import { reportStatsReducer } from "./reducers/reportStatsReducer";
import { reportTransactionsReducer } from "./reducers/reportTransactions";
import { payoutAuditLogReducer } from "./reducers/payoutAuditLogReducer";
import { getMerchantsBankAccountsReducer } from "./reducers/getMerchantBankAccountsReduce";

import { payoutConfigurationsReducer } from "./reducers/payoutConfigurationsReducer";
import { getTrxReqReducer, getTrxResReducer } from "./reducers/getTrsReqResReducer";
import { editMerchantAvailableTerminalReducer } from "./reducers/editAvailableTerminalReducer";
import { ClickToPayReducer } from "./reducers/addClickToPayReducer";
import { amsThreatsReducer } from "./reducers/amsThreatsReducer";
import { AllSummaryThreadsReducer, DataByDateFromMerchantControlReducer, Top3DetectionNameFromMerchantControlReducer, Top5TerminalIdFromMerchantControlReducer } from "./reducers/threatsDashboardReducer";
import { getSdkLoginTokenReducer } from "./reducers/GetSdkTokenReducer";
import { TabbyReducer } from "./reducers/addTabbyReducer";
import { selectedMerchantRegistrationReducer } from "./reducers/selectedMerchantRegistrationReducer";
import { verifyMerchantIbanReducer } from "./reducers/verifyMerchantIbanReducer";
import { getAllTransactionTypesReducer } from "./reducers/getAllTransactionTypesReducer";
import { getAllPaymentSchemeReducer } from "./reducers/getAllPaymentSchemeReducer";
import { getMerchantRefundPaymentConfigReducer } from "./reducers/getMerchantRefundPaymentConfigReducer";
import { updateMerchantRefundPaymentConfigReducer } from "./reducers/updateMerchantRefundPaymentConfigReducer";
import { getUserRefundPaymentConfigByMerchantIdReducer } from "./reducers/getUserRefundPaymentConfigByMerchantIdReducer";
import { updateUserRefundPaymentConfigReducer } from "./reducers/updateUserRefundPaymentConfigReducer";
import { productCrudReducer } from "./reducers/productReducer";
import { customerCrudReducer } from "./reducers/CustomerReducer";
import { mpgsCrudReducer } from "./reducers/mpgsReducer";

export const appReducer = combineReducers({
  payoutAuthReducer,



  authReducer,
  otpReducer,
  resendOtpReducer,
  ResetPasswordFirstLoginReducer,
  getMerchantsReducer,
  createMerchantReducer,
  editMerchantReducer,
  createUserReducer,
  merchantReducer,
  partnerReducer,
  outLetsByMerchantReducer,
  outletDetailsReducer,
  getUsersReducer,
  getTerminalsReducer,
  AddTerminalTmsCardReducer,
  AddTerminalRetailerReducer,
  AddTerminalReducer,
  getMerchantAvailableTerminalReducer,
  editMerchantAvailableTerminalReducer,

  DeleteTerminalReducer,
  deleteMerchantReducer,
  editTerminalReducer,
  merchantSummaryReducer,
  userSummaryReducer,
  getOutletsTerminalsReducer,
  getUsersByOutletId,
  getUsersTerminalsReducer,
  getMerchntTransactionsReducer,
  getUsersTransactionsReducer,
  getTsnTransactionsReducer,
  getTerminalSummaryReducer,
  getOutletSummaryReducer,
  editUserReducer,
  editOutletReducer,
  addOutletReducer,
  getListOfCurrency,
  getListOfBusinessCategory,
  addCurrencyReducer,
  getCountriesCitiesReducer,
  getListOfFilterSearchReducer,

  transactionsFilterReducer,

  getMerchantTodayBalanceReducer,
  getTopUsedTerminalReducer,
  getlast7DaysTransactionCountReducer,
  getMerchantCurrentPreviousReducer,
  getMerchantUsedSchemeReducer,
  getTerminalsTransactionChartReducer,
  getOutletsTransactionChartReducer,
  getReconcilationHistoryReducer,
  getReconciliationFilterReducer,

  createInvoiceReducer,
  merchantInvoicesReducer,
  invoicesFilterReducer,
  merchantInvoiceReducer,
  getPaymentConfigReducer,
  addMerchantPaymentConfigurationReducer,
  getInvoicePaymentUrlReducer,
  EditInvoiceStatusReducer,
  SendInvoiceNotificationReducer,

  paymentGatewayTransactionReducer,
  paymentGatewayTrxReducer,
  dashboardDataReducer,
  fetchDashboardData,
  paymentGatewayHighlightsReducer,
  payementMethodsReducer,
  geopayementReducer,
  paymentChartReducer,
  addApplePayConfigReducer,
  updateCardConfigReducer,
  getMerchantPaymentConfigReducer,
  addUrpayConfigReducer,
  addCardConfigReducer,
  geturpayConfigReducer,
  updateurpayConfigReducer,
  forgotPwReducer,
  findAppleConfigReducer,
  updateAppleConfigReducer,
  addNewMerchantReducer,
  manafithReducer,
  sadadConfigReducer,
  TamaraReducer,
  getTerminalsListReducer,
  ////
  addNewProductReducer,
  getProductListReducer,
  DeleteProductReducer,
  editProductReducer,
  ////
  addNewCustomerReducer,
  getCustomerListReducer,
  DeleteCustomerReducer,
  editCustomerReducer,
  ClickToPayReducer,
  /////
  getAllCountryReducer,
  addNewCountryReducer,
  editCountryReducer,
  ///
  getAllCityReducer,
  addNewCityReducer,
  editCityReducer,
  ///
  addNewCurrencyReducer,
  getAllCurrencyReducer,
  editCurrencyReducer,
  deleteCurrencyReducer,
  ///
  getAllTmsReducer,
  addTmsReducer,
  activateTMSReducer,
  deactivateTmsReducer,
  ///
  getAllBusinessCategoryReducer,
  updateBusCatReducer,
  addBusinessCategoryReducer,
  activateBusinessCategoryReducer,
  deactivateBusinessCategoryReducer,
  ///
  getAllRetailerReducer,
  editRetailerReducer,
  addRetailerReducer,
  ///
  addNewTransferChargeReducer,
  getAllTransferChargeReducer,
  editTransferChargeReducer,
  deleteTransferChargeReducer,

  //
  partnerCrudReducer,

  merchantOnlineRegisterReducer,

  ////
  //deleteMerchantReducer
  //
  getAuditReducer,
  //
  getAllPaymentGyListReducer,
  //
  getApplePayTrxReducer,
  //
  versionsCrudOperationsReducer,

  //

  partnerThemeCrudOperationsReducer,
  getOnBoardingFilesReducer,
  //TRX RQ RS
  getTrxReqReducer,
  getTrxResReducer,

  //payment schedule
  paymentScheduleCrudReducer,

  // fee profile
  getAllFeeProfileReducer,
  addFeeProfileReducer,
  editFeeProfileReducer,
  ChangeFeeProfileStatusReducer,
  DeleteFeeProfileReducer,

  // fee plans
  feePlanReducer,
  //payout
  payoutMerchantCrudReducer,

  resendFailedVirtualAccountsReducer,

  getAssociatedBanksReducer,

  getPayoutTransactionsReportsReducer,
  getPOSTransactionsReportsReducer,
  getMerchantPosTransctionsReducer,

  singlePayoutTransactionReducer,
  payoutTransactionsReducer,
  payoutMerchantsReducer,

  getVirtualAccountsReducer,
  reportStatsReducer,
  reportTransactionsReducer,
  payoutAuditLogReducer,

  getMerchantsBankAccountsReducer,
  payoutConfigurationsReducer,
  amsThreatsReducer,
  AllSummaryThreadsReducer,
  Top5TerminalIdFromMerchantControlReducer,
  Top3DetectionNameFromMerchantControlReducer,
  DataByDateFromMerchantControlReducer,
  getSdkLoginTokenReducer,
  TabbyReducer,
  selectedMerchantRegistrationReducer,
  verifyMerchantIbanReducer,
  getAllTransactionTypesReducer,
  getAllPaymentSchemeReducer,
  getMerchantRefundPaymentConfigReducer,
  updateMerchantRefundPaymentConfigReducer,
  getUserRefundPaymentConfigByMerchantIdReducer,
  updateUserRefundPaymentConfigReducer,

  productCrudReducer,
  customerCrudReducer,
  mpgsCrudReducer
});

export const rootReducers = (state: any, action: any) => {
  if (action.type === "LOG_OUT") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducers>;
